export const GI_OVERDUE_DASHBOARD_BUCKETS = [
  { id: "all", label: "All", test: () => true },
  { id: "d120p", label: "> 120 days", test: (d) => d >= 120 },
  { id: "d90_120", label: "90 - 120 days", test: (d) => d >= 90 && d < 120 },
  { id: "d60_90", label: "60 - 90 days", test: (d) => d >= 60 && d < 90 },
  { id: "d30_60", label: "30 - 60 days", test: (d) => d >= 30 && d < 60 },
  { id: "d0_30", label: "0 - 30 days", test: (d) => d > 0 && d < 30 },
];

export const GI_CONSULTANT_OVERDUE_BUCKETS = [
  { id: "all", label: "All", test: () => true },
  { id: "d120p", label: "> 120 days", test: (d) => d >= 120 },
  { id: "d90_120", label: "90 - 120 days", test: (d) => d >= 90 && d < 120 },
  { id: "d60_90", label: "60 - 90 days", test: (d) => d >= 60 && d < 90 },
  { id: "d30_60", label: "30 - 60 days", test: (d) => d >= 30 && d < 60 },
  { id: "d0_30", label: "0 - 30 days", test: (d) => d >= 0 && d < 30 },
];

export const GI_OVERDUE_SUMMARY_BUCKETS = GI_OVERDUE_DASHBOARD_BUCKETS.filter(
  (bucket) => bucket.id !== "all"
);

export const GI_CONSULTANT_SUMMARY_BUCKETS = GI_CONSULTANT_OVERDUE_BUCKETS.filter(
  (bucket) => bucket.id !== "all"
);

export const DEFAULT_CONSULTANT_FILTERS = {
  paymentStatus: ["WAIT", "PARTIAL"],
  status: ["CONFIRMED"],
  policyStatus: [],
};

export const CONSULTANT_PAYMENT_STATUS_OPTIONS = [
  { value: "WAIT", label: "Waiting" },
  { value: "PARTIAL", label: "Partial" },
  { value: "MATCHING", label: "Matching" },
  { value: "DIRECT", label: "Direct" },
  { value: "PAID", label: "Paid" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "SETTLED", label: "Settled" },
];

export const CONSULTANT_DN_STATUS_OPTIONS = [
  { value: "DFT", label: "Draft" },
  { value: "CAN", label: "Cancel" },
  { value: "HOLD", label: "Hold" },
  { value: "CONFIRMED", label: "Confirm" },
  { value: "EXP", label: "Expired" },
];

export const CONSULTANT_POLICY_STATUS_OPTIONS = [
  { value: "NONE", label: "None" },
  { value: "POLICY_RECEIVED", label: "Policy Received" },
  { value: "POLICY_DISPATCHED", label: "Policy Dispatched" },
];

export const filterRowsByOverdueBucket = (
  rows,
  bucketId,
  buckets = GI_OVERDUE_DASHBOARD_BUCKETS
) => {
  const bucket =
    buckets.find((b) => b.id === bucketId) || buckets[0];
  return (rows || []).filter((row) =>
    bucket.test(Number(row.overdueDays) || 0)
  );
};

export const filterGroupsByBucket = (groups, bucketId) => {
  if (!bucketId || bucketId === "all") return groups || [];
  return (groups || []).filter(
    (group) => (group.buckets?.[bucketId]?.count || 0) > 0
  );
};

export const filterInsurersByBucket = filterGroupsByBucket;

export const extractClientOptionsFromRows = (rows) =>
  [...new Set((rows || []).map((r) => r.clientLabel || r.clientName).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({ value: name, label: name }));

export const filterRowsByClient = (rows, selectedClients) => {
  if (!selectedClients?.length) return rows || [];
  return (rows || []).filter((row) =>
    selectedClients.includes(row.clientLabel || row.clientName)
  );
};

export const getAllConsultantDashboardRows = (dashboard, showGroupedView) => {
  if (!dashboard) return [];
  if (showGroupedView) {
    return (dashboard.consultants || []).flatMap((g) => g.rows || []);
  }
  return dashboard.rows || [];
};

export const formatOverdueBucketAmounts = (amountsByCurrency, formatCurrency) => {
  const entries = Object.entries(amountsByCurrency || {}).filter(
    ([, amount]) => amount
  );
  if (!entries.length) {
    return formatCurrency(0);
  }
  return entries
    .map(([currency, amount]) => formatCurrency(amount, currency))
    .join(" · ");
};

export const formatBucketCountAmount = (
  bucket,
  formatCurrency,
  emptyLabel = "-"
) => {
  if (!bucket?.count) return emptyLabel;
  const amount = formatOverdueBucketAmounts(
    bucket.amountsByCurrency,
    formatCurrency
  );
  return `${amount} (${bucket.count})`;
};

export const getOverdueSummaryColor = (bucketId) => {
  switch (bucketId) {
    case "d0_30":
      return "green";
    case "d30_60":
      return "yellow";
    case "d60_90":
      return "orange";
    case "d90_120":
      return "red";
    case "d120p":
      return "grape";
    default:
      return "gray";
  }
};

export const getOverdueSummaryLabelKey = (bucketId) =>
  `dashboard.giOverdue.buckets.${bucketId}`;
